;'use strict';
$(document).ready(function(){

	$.fn.addExpandableBreadcrumb = function(){

		var $breadcrumbContainer = $(this),
			$breadcrumbList = $('.b--list',$breadcrumbContainer),
			initialHeight = parseInt($breadcrumbList.height()),
			lineHeight = $breadcrumbList.children().first().height(),
			toTranslate = (initialHeight - 2*lineHeight);

		var nextTranslation = toTranslate;
		// Force 2 lines height 
		$breadcrumbList
			.addClass('b--expandable')
			.height(2*lineHeight)
			.prepend('<li class="b--expcol" aria-hidden="true"><a href="#">[+]</a></li>');

		// Show last elements of the breadcrumb
		$breadcrumbList
			.find('li:not(.b--expcol)')
				.css('transform','translateY(-'+ toTranslate +'px)');

		// Expand/Collapse of the breadcrumb
		$('.b--expcol',$breadcrumbList).on('click',function __onExpCollapseClick(e){
            
            $(this).toggleClass("opened");
            
            if ( $( this ).hasClass( "opened" ) ) {
                $(this).attr("aria-hidden", 'false');
                $(this).html( "<a href='#'>[&minus;]</a>" );
            }
            else{
                $(this).attr("aria-hidden", 'true');
                $(this).html( "<a href='#'>[+]</a>" );
            }
            
			e.preventDefault();

			if(toTranslate == nextTranslation){ // Expand
				nextTranslation = 0;
				$breadcrumbList.animate({height:initialHeight},300);
			}
			else{
				nextTranslation = toTranslate; // Collapse
				$breadcrumbList.animate({height:2*lineHeight},300);
			}

			$breadcrumbList
				.find('li:not(.b--expcol)')
					.css('transform','translateY(-'+ nextTranslation +'px)');

			return false;
		});
		return this;
	};

	$.fn.removeExpandableBreadcrumb = function(){
		var $breadcrumbContainer = $(this),
			$breadcrumbList = $('.b--list',$breadcrumbContainer);

		$breadcrumbList
			.removeClass('b--expandable')
			.css('height','auto')
			.find('.b--expcol')
				.remove();

		$breadcrumbList
			.find('li:not(.b--expcol)')
				.css('transform','');

		return this;
	}

	function expandableBreadcrumb(){

		$('.breadcrumb')
			.removeExpandableBreadcrumb()
			.each(function _collapsableBreadcrumb(){

				var $breadcrumbContainer = $(this),
					$breadcrumbList = $('.b--list',$breadcrumbContainer),
					lineHeight = $breadcrumbList.children().first().height();

				// If the breacrumb reach 3lines add expand/collapse
				if($breadcrumbList.height() > 2*lineHeight && !$breadcrumbList.hasClass('b--expandable')){
					$breadcrumbContainer.addExpandableBreadcrumb();
				}
			});			
	}

	// Expandable breadcrumb disabled by T3764-5938
	//$(window).on('resize', expandableBreadcrumb);

	// Init
	//expandableBreadcrumb();
});